function updateSchedule(busStop) {
  return (
    fetch("https://us-central1-bus-project-260612.cloudfunctions.net/bus-app-update/api/" + busStop.toString(), {
      mode: "cors",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      // .then((data) => {
      //   //console.log(data);
      //   return Promise(data);
      // })
      .catch((error) => console.error(error))
  );
}

export default updateSchedule;

//updateSchedule();
//setInterval(updateSchedule, 60000);
